/* Homepage interactions: native scrolling, no autoplay, no third-party libraries. */
(() => {
  function init(root = document) {
    const home = root.querySelector('[data-mood-home]');
    if (!home || home.dataset.ready) return;
    home.dataset.ready = 'true';
    // The Shopify draft bar must not cover the mobile navigation while reviewing.
    let previewBar;
    const updatePreviewBar = () => {
      const frameHeight = previewBar ? previewBar.getBoundingClientRect().height : 0;
      const parentHeight = previewBar?.parentElement?.getBoundingClientRect().height || 0;
      const height = frameHeight > 140 ? (parentHeight > 0 && parentHeight < 140 ? parentHeight : 64) : frameHeight;
      document.body.style.setProperty('--mh-preview-bar-height', `${height > 0 && height < 140 ? height : 0}px`);
    };
    const findPreviewBar = () => {
      const bar = document.getElementById('PBarNextFrame');
      if (bar && bar !== previewBar) {
        previewBar = bar;
        new ResizeObserver(updatePreviewBar).observe(bar);
      }
      updatePreviewBar();
    };
    new MutationObserver(findPreviewBar).observe(document.body, {childList:true});
    findPreviewBar();
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const behavior = () => reducedMotion.matches ? 'instant' : 'smooth';
    const carousel = home.querySelector('[data-mh-slides]');
    if (carousel) {
    const slides = [...carousel.querySelectorAll('[data-mh-slide]')];
    const dots = [...home.querySelectorAll('[data-mh-dot]')];
    let current = 0;
    function update(index) {
      current = index;
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-pressed', String(i === index));
      });
      slides.forEach((slide, i) => {
        if ('inert' in slide) slide.inert = i !== index;
      });
    }
    function go(index) {
      index = (index + slides.length) % slides.length;
      const target = slides[index];
      carousel.scrollTo({left: target.offsetLeft - slides[0].offsetLeft, behavior: behavior()});
      update(index);
    }
    dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
    home.querySelector('[data-mh-prev]').addEventListener('click', () => go(current - 1));
    home.querySelector('[data-mh-next]').addEventListener('click', () => go(current + 1));
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        go(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio > .6) update(slides.indexOf(entry.target));
      });
    }, {root: carousel, threshold: [.6]});
    slides.forEach(slide => observer.observe(slide));
    update(0);
    }
    const stories = home.querySelector('[data-mh-stories]');
    const storyNext = home.querySelector('[data-mh-stories-next]');
    if (storyNext && stories) storyNext.addEventListener('click', () => {
      const rtl = getComputedStyle(stories).direction === 'rtl';
      const max = stories.scrollWidth - stories.clientWidth;
      const reset = Math.abs(stories.scrollLeft) >= max - 5;
      stories.scrollTo({left: reset ? 0 : stories.scrollLeft + (rtl ? -1 : 1) * stories.clientWidth * .8, behavior: behavior()});
    });
    const dialog = home.querySelector('#mh-menu');
    let opener;
    document.querySelectorAll('[data-mh-open="mh-menu"]').forEach(button => {
      button.addEventListener('click', () => {
        opener = button;
        dialog.showModal();
        document.body.classList.add('mh-dialog-open');
      });
    });
    const close = () => dialog.close();
    dialog.querySelector('[data-mh-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => {if (event.target === dialog) close();});
    dialog.addEventListener('close', () => {
      document.body.classList.remove('mh-dialog-open');
      opener?.focus();
    });
    dialog.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', close));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', () => init());
})();
